

const Name_en = (cell) => {
  return cell.value ? cell.value : '';
};
const Name_services_en = (cell) => {
  return cell.value ? cell.value : '';
};

const Name_ar = (cell) => {
  return cell.value ? cell.value : '';
};
const Name_fr = (cell) => {
  return cell.value ? cell.value : '';
};
const IsActive = cell => {
  return cell.value ? cell.value : ""
}



export { Name_ar, Name_en,Name_fr, IsActive,Name_services_en}